import React from 'react';
import { createRoot } from "react-dom/client";
import './index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import isLegalCopy from './copy-protection';
import { Router } from 'wouter';
import { useHashLocation } from 'wouter/use-hash-location';

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router hook={useHashLocation}>
        {isLegalCopy ? <App /> : "This page is not available."}
      </Router>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
